/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { get } from "@ember/object";
import ScaleSurveyEditionFormComponent from "core/components/abstract/scale-survey-edition-form";
import YmrsDeclaredJournalEvent from "core/models/ymrs-declared-journal-event";
import ymrsScoreDescription from "core/utils/ymrs-score-description";
export default class YMRSEditionComponent extends ScaleSurveyEditionFormComponent {
  get numberOfItems() {
    return 11;
  }
  get maximalScore() {
    return 60;
  }
  get validationNames() {
    return ["L'élévation de l'humeur", "L'activité motrice et énergie augmentées", "L'intérêt sexuel", "Le sommeil", "L'irritabilité", "Le discours (débit et quantité)", "Le langage – troubles de la pensée", "Le contenu", "Le comportement agressif et perturbateur", "L'apparence", "L'introspection"];
  }

  // payload will either be a changeset (when template refreshes),
  // or a POJO (when the form is saved).
  _computeScore(payload) {
    const number = this.questionIds.reduce((total, index) => total + parseInt(get(payload, index)), 0);
    return {
      number,
      description: ymrsScoreDescription(number)
    };
  }
}
_defineProperty(YMRSEditionComponent, "forcDisplayName", "Young Mania Rating Scale");
_defineProperty(YMRSEditionComponent, "fullComponentId", "scale-surveys/ymrs-edition-form");
_defineProperty(YMRSEditionComponent, "journalEventClass", YmrsDeclaredJournalEvent);